"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _ModalNewApplication = _interopRequireDefault(require("./components/ModalNewApplication"));
var _ApplicationDetailsModal = _interopRequireDefault(require("./components/ApplicationDetailsModal"));
var _vuex = require("vuex");
var _application = require("@/services/application.service");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'Aplicacao',
  components: {
    Page: _Page.default,
    ApplicationDetailsModal: _ApplicationDetailsModal.default
  },
  data: function data() {
    return {
      applications: [],
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      dateStart: (0, _moment.default)().startOf('year').toDate(),
      dateEnd: (0, _moment.default)().endOf('year').toDate(),
      isLoading: false,
      selectedApplication: null,
      showApplicationModal: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)({
    menuItems: 'menuItemsApplications',
    farm: 'GET_FARM',
    user: 'userAdmin'
  })),
  watch: {
    'farm.id': {
      handler: function handler(newVal) {
        if (newVal) {
          this.getApplications();
        }
      },
      immediate: true
    }
  },
  methods: {
    onPageChange: function onPageChange(i) {
      this.currentPage = i;
      this.getApplications();
    },
    getApplications: function () {
      var _getApplications = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$farm,
          _this = this;
        var page,
          _response$meta,
          params,
          _yield$applicationSer,
          response,
          responseData,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              page = _args.length > 0 && _args[0] !== undefined ? _args[0] : 1;
              if ((_this$farm = this.farm) !== null && _this$farm !== void 0 && _this$farm.id) {
                _context.n = 1;
                break;
              }
              this.isLoading = false;
              return _context.a(2);
            case 1:
              this.isLoading = true;
              _context.p = 2;
              params = {
                startDate: (0, _moment.default)(this.dateStart).format('YYYY-MM-DD'),
                endDate: (0, _moment.default)(this.dateEnd).format('YYYY-MM-DD'),
                page: page
              };
              _context.n = 3;
              return _application.applicationService.fetchApplicationsByDateRange(this.farm.id, params);
            case 3:
              _yield$applicationSer = _context.v;
              response = _yield$applicationSer.data;
              responseData = Array.isArray(response.data) ? response.data : [];
              this.applications = responseData.map(function (app) {
                var _app$sector, _app$prescription, _app$prescription2, _app$prescription3, _app$prescription4, _app$prescription5, _app$prescription5$pr, _app$prescription6, _app$sector2, _app$equipment;
                return {
                  id: app.id,
                  status: app.status,
                  local: ((_app$sector = app.sector) === null || _app$sector === void 0 ? void 0 : _app$sector.name) || '--',
                  dataAplicacao: app.applicationDate,
                  prescricao: ((_app$prescription = app.prescription) === null || _app$prescription === void 0 ? void 0 : _app$prescription.name) || '--',
                  prescricaoCategoria: ((_app$prescription2 = app.prescription) === null || _app$prescription2 === void 0 ? void 0 : _app$prescription2.category) || null,
                  prescricaoDescricao: ((_app$prescription3 = app.prescription) === null || _app$prescription3 === void 0 ? void 0 : _app$prescription3.description) || null,
                  prescricaoProductsDosage: ((_app$prescription4 = app.prescription) === null || _app$prescription4 === void 0 ? void 0 : _app$prescription4.productsDosage) || [],
                  produtos: ((_app$prescription5 = app.prescription) === null || _app$prescription5 === void 0 ? void 0 : (_app$prescription5$pr = _app$prescription5.productsDosage) === null || _app$prescription5$pr === void 0 ? void 0 : _app$prescription5$pr.map(function (p) {
                    return p.productName;
                  })) || [],
                  tempoTrabalho: app.totalDuration ? _this.formatDuration(app.totalDuration) : '--',
                  periodoAplicacao: _this.formatPeriodoAplicacao(app.returnDays),
                  aplicador: app.user ? "".concat(app.user.firstName, " ").concat(app.user.lastName) : '--',
                  equipamento: app.equipment ? "".concat(app.equipment.name, " (").concat(app.equipment.type, ")") : '--',
                  description: app.description || null,
                  observation: app.observation || null,
                  returnDays: app.returnDays,
                  isRecurrent: app.returnDays > 0,
                  prescricaoId: (_app$prescription6 = app.prescription) === null || _app$prescription6 === void 0 ? void 0 : _app$prescription6.id,
                  setorId: (_app$sector2 = app.sector) === null || _app$sector2 === void 0 ? void 0 : _app$sector2.id,
                  equipamentoId: (_app$equipment = app.equipment) === null || _app$equipment === void 0 ? void 0 : _app$equipment.id,
                  prescription: app.prescription,
                  sector: app.sector,
                  equipment: app.equipment
                };
              });
              this.totalItems = ((_response$meta = response.meta) === null || _response$meta === void 0 ? void 0 : _response$meta.total) || this.applications.length;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.error('Erro ao carregar aplicações:', _t);
              this.applications = [];
              this.totalItems = 0;
            case 5:
              _context.p = 5;
              this.isLoading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function getApplications() {
        return _getApplications.apply(this, arguments);
      }
      return getApplications;
    }(),
    updateApplicationStatus: function () {
      var _updateApplicationStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(application, newStatus) {
        var returnDays,
          observation,
          data,
          _error$response,
          _error$response$data,
          _args2 = arguments,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              returnDays = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
              observation = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : null;
              _context2.p = 1;
              data = {
                farmId: this.farm.id,
                status: newStatus
              };
              if (newStatus === 'FINISHED') {
                if (returnDays !== null) {
                  data.returnDays = returnDays;
                }
                if (observation) {
                  data.observation = observation;
                }
              }
              _context2.n = 2;
              return _application.applicationService.updateApplication(application.id, data);
            case 2:
              if (!(newStatus === 'FINISHED' && returnDays > 0)) {
                _context2.n = 3;
                break;
              }
              _context2.n = 3;
              return this.createReturnApplication(application, returnDays);
            case 3:
              this.getApplications(this.currentPage);
              this.$buefy.toast.open({
                message: 'Status atualizado com sucesso',
                type: 'is-success'
              });
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.error('Erro ao atualizar status:', _t2);
              this.$buefy.toast.open({
                message: "Erro ao atualizar status: ".concat(((_error$response = _t2.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || _t2.message),
                type: 'is-danger'
              });
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 4]]);
      }));
      function updateApplicationStatus(_x, _x2) {
        return _updateApplicationStatus.apply(this, arguments);
      }
      return updateApplicationStatus;
    }(),
    createReturnApplication: function () {
      var _createReturnApplication = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(originalApplication, returnDays) {
        var _response$data, _appData$prescription, _appData$sector, _appData$equipment, newApplicationDate, _yield$applicationSer2, response, fullApp, appData, prescriptionId, sectorId, equipmentId, data, _error$response2, _error$response2$data, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              newApplicationDate = (0, _moment.default)().add(returnDays, 'days').format('YYYY-MM-DD');
              _context3.n = 1;
              return _application.applicationService.fetchApplicationsByDateRange(this.farm.id, {
                startDate: (0, _moment.default)(originalApplication.dataAplicacao).format('YYYY-MM-DD'),
                endDate: (0, _moment.default)(originalApplication.dataAplicacao).format('YYYY-MM-DD')
              });
            case 1:
              _yield$applicationSer2 = _context3.v;
              response = _yield$applicationSer2.data;
              fullApp = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.find(function (app) {
                return app.id === originalApplication.id;
              });
              appData = fullApp || originalApplication;
              prescriptionId = ((_appData$prescription = appData.prescription) === null || _appData$prescription === void 0 ? void 0 : _appData$prescription.id) || appData.prescricaoId;
              sectorId = ((_appData$sector = appData.sector) === null || _appData$sector === void 0 ? void 0 : _appData$sector.id) || appData.setorId;
              equipmentId = ((_appData$equipment = appData.equipment) === null || _appData$equipment === void 0 ? void 0 : _appData$equipment.id) || appData.equipamentoId;
              if (!(!prescriptionId || !sectorId)) {
                _context3.n = 2;
                break;
              }
              throw new Error('Dados insuficientes para criar aplicação de retorno: prescrição e setor são obrigatórios');
            case 2:
              data = {
                farmId: this.farm.id,
                prescriptionId: prescriptionId,
                sectorIds: [sectorId],
                equipmentId: equipmentId || null,
                userId: this.user.id,
                status: 'PENDING',
                applicationDate: newApplicationDate,
                description: appData.description || 'Aplicação de retorno'
              };
              _context3.n = 3;
              return _application.applicationService.createApplication(data);
            case 3:
              this.$buefy.toast.open({
                message: "Nova aplica\xE7\xE3o agendada para ".concat((0, _moment.default)().add(returnDays, 'days').format('DD/MM/YYYY')),
                type: 'is-info'
              });
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              console.error('Erro ao criar aplicação de retorno:', _t3);
              this.$buefy.toast.open({
                message: "Erro ao criar aplica\xE7\xE3o de retorno: ".concat(((_error$response2 = _t3.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message) || _t3.message),
                type: 'is-warning'
              });
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 4]]);
      }));
      function createReturnApplication(_x3, _x4) {
        return _createReturnApplication.apply(this, arguments);
      }
      return createReturnApplication;
    }(),
    openStatusModal: function openStatusModal(application) {
      this.$buefy.modal.open({
        parent: this,
        component: {
          template: "\n            <div class=\"modal-card\">\n              <header class=\"modal-card-head\">\n                <p class=\"modal-card-title\">Atualizar Status</p>\n                <button class=\"delete\" @click=\"$parent.close()\"></button>\n              </header>\n              <section class=\"modal-card-body\">\n                <b-field label=\"Status\">\n                  <b-select v-model=\"selectedStatus\" expanded>\n                    <option v-if=\"application.status === 'PENDING'\" value=\"IN_PROGRESS\">Em progresso</option>\n                    <option v-if=\"application.status === 'IN_PROGRESS'\" value=\"PAUSED\">Pausado</option>\n                    <option v-if=\"application.status === 'IN_PROGRESS'\" value=\"FINISHED\">Finalizado</option>\n                    <option v-if=\"application.status === 'PAUSED'\" value=\"IN_PROGRESS\">Em progresso</option>\n                  </b-select>\n                </b-field>\n                \n                <div v-if=\"selectedStatus === 'FINISHED'\">\n                  <b-field label=\"Observa\xE7\xE3o\">\n                    <b-input v-model=\"observation\" type=\"textarea\" placeholder=\"Adicione observa\xE7\xF5es sobre a aplica\xE7\xE3o...\"></b-input>\n                  </b-field>\n                  \n                  <b-field label=\"Dias para retorno\">\n                    <b-input v-model=\"returnDays\" type=\"number\" min=\"0\" placeholder=\"Ex: 30\" :disabled=\"isUnicaAplicacao\"></b-input>\n                  </b-field>\n                  \n                  <b-field>\n                    <b-checkbox v-model=\"isUnicaAplicacao\" @input=\"onUnicaAplicacaoChange\">\n                      \xDAnica aplica\xE7\xE3o\n                    </b-checkbox>\n                  </b-field>\n                </div>\n              </section>\n              <footer class=\"modal-card-foot\">\n                <b-button @click=\"$parent.close()\">Cancelar</b-button>\n                <b-button type=\"is-primary\" @click=\"updateStatus\">Atualizar</b-button>\n              </footer>\n            </div>\n          ",
          data: function data() {
            var getInitialStatus = function getInitialStatus() {
              if (application.status === 'PENDING') return 'IN_PROGRESS';
              if (application.status === 'IN_PROGRESS') return 'PAUSED';
              if (application.status === 'PAUSED') return 'IN_PROGRESS';
              return application.status;
            };
            return {
              selectedStatus: getInitialStatus(),
              returnDays: application.returnDays || '',
              isUnicaAplicacao: false,
              observation: '',
              application: application
            };
          },
          methods: {
            onUnicaAplicacaoChange: function onUnicaAplicacaoChange(value) {
              if (value) {
                this.returnDays = '0';
              } else {
                this.returnDays = '';
              }
            },
            updateStatus: function updateStatus() {
              var returnDaysValue = null;
              if (this.selectedStatus === 'FINISHED') {
                returnDaysValue = this.isUnicaAplicacao ? 0 : parseInt(this.returnDays) || null;
              }
              var observationValue = this.selectedStatus === 'FINISHED' ? this.observation : null;
              this.$parent.close();
              this.$parent.$parent.updateApplicationStatus(application, this.selectedStatus, returnDaysValue, observationValue);
            }
          }
        },
        hasModalCard: true
      });
    },
    openApplicationModal: function openApplicationModal() {
      var application = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.$buefy.modal.open({
        parent: this,
        component: _ModalNewApplication.default,
        hasModalCard: false,
        customClass: 'modal-new-application',
        trapFocus: true,
        canCancel: ['escape'],
        props: {
          application: application,
          onSuccess: this.resolvedCallback,
          createApplication: this.createApplication,
          updateApplication: this.updateApplication
        }
      });
    },
    editApplication: function editApplication(application) {
      this.openApplicationModal(application);
    },
    deleteApplication: function deleteApplication(application) {
      var _this2 = this;
      this.$buefy.dialog.confirm({
        title: 'Excluir Aplicação',
        message: "Tem certeza de que deseja excluir esta aplica\xE7\xE3o?",
        confirmText: 'Excluir',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
            var _t4;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.p = _context4.n) {
                case 0:
                  _context4.p = 0;
                  _context4.n = 1;
                  return _application.applicationService.deleteApplication(application.id, _this2.farm.id);
                case 1:
                  _this2.$buefy.toast.open({
                    message: 'Aplicação excluída com sucesso!',
                    type: 'is-success'
                  });
                  _this2.getApplications(_this2.currentPage);
                  _context4.n = 3;
                  break;
                case 2:
                  _context4.p = 2;
                  _t4 = _context4.v;
                  console.error('Erro ao excluir aplicação:', _t4);
                  _this2.$buefy.toast.open({
                    message: 'Erro ao excluir aplicação. Tente novamente.',
                    type: 'is-danger'
                  });
                case 3:
                  return _context4.a(2);
              }
            }, _callee4, null, [[0, 2]]);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    },
    createApplication: function () {
      var _createApplication = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(form) {
        var data, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              data = {
                farmId: this.farm.id,
                prescriptionId: form.prescricaoId,
                sectorIds: form.sectorIds,
                equipmentId: form.equipamentoId,
                userId: this.user.id,
                status: 'PENDING',
                applicationDate: form.dataAplicacao,
                description: form.descricao
              };
              _context5.n = 1;
              return _application.applicationService.createApplication(data);
            case 1:
              this.$buefy.toast.open({
                message: 'Aplicação criada com sucesso!',
                type: 'is-success'
              });
              return _context5.a(2, true);
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.error('Erro ao criar aplicação:', _t5);
              this.$buefy.toast.open({
                message: 'Erro ao criar aplicação. Tente novamente.',
                type: 'is-danger'
              });
              return _context5.a(2, false);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function createApplication(_x5) {
        return _createApplication.apply(this, arguments);
      }
      return createApplication;
    }(),
    updateApplication: function () {
      var _updateApplication = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(form, application) {
        var data, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              data = {
                farmId: this.farm.id
              };
              if (form.prescricaoId) {
                data.prescriptionId = form.prescricaoId;
              }
              if (form.setorId) {
                data.sectorId = form.setorId;
              }
              if (form.equipamentoId) {
                data.equipmentId = form.equipamentoId;
              }
              if (form.dataAplicacao) {
                data.applicationDate = _moment.default.utc(form.dataAplicacao).format('YYYY-MM-DD');
              }
              if (form.descricao) {
                data.description = form.descricao;
              }
              _context6.n = 1;
              return _application.applicationService.updateApplication(application.id, data);
            case 1:
              this.$buefy.toast.open({
                message: 'Aplicação editada com sucesso!',
                type: 'is-success'
              });
              return _context6.a(2, true);
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              console.error('Erro ao editar aplicação:', _t6);
              this.$buefy.toast.open({
                message: 'Erro ao editar aplicação. Tente novamente.',
                type: 'is-danger'
              });
              return _context6.a(2, false);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function updateApplication(_x6, _x7) {
        return _updateApplication.apply(this, arguments);
      }
      return updateApplication;
    }(),
    resolvedCallback: function resolvedCallback() {
      this.currentPage = 1;
      this.getApplications();
    },
    applyDateFilter: function applyDateFilter() {
      this.currentPage = 1;
      this.getApplications();
    },
    clearDateFilter: function clearDateFilter() {
      this.dateStart = null;
      this.dateEnd = null;
      this.currentPage = 1;
      this.getApplications();
    },
    getStatusType: function getStatusType(status, applicationDate) {
      if (status === 'PENDING' && applicationDate) {
        var today = (0, _moment.default)().startOf('day');
        var appDate = (0, _moment.default)(applicationDate).startOf('day');
        if (appDate.isBefore(today)) {
          return 'is-warning'; // Laranja para atraso
        }
      }
      var types = {
        'PENDING': 'is-light',
        'IN_PROGRESS': 'is-info',
        'PAUSED': 'is-danger',
        'FINISHED': 'is-success'
      };
      return types[status] || 'is-light';
    },
    getStatusLabel: function getStatusLabel(status, applicationDate) {
      if (status === 'PENDING' && applicationDate) {
        var today = (0, _moment.default)().startOf('day');
        var appDate = (0, _moment.default)(applicationDate).startOf('day');
        if (appDate.isBefore(today)) {
          return 'ATRASADO';
        }
      }
      var labels = {
        'PENDING': 'PENDENTE',
        'IN_PROGRESS': 'EM ANDAMENTO',
        'PAUSED': 'PAUSADO',
        'FINISHED': 'FINALIZADO'
      };
      return labels[status] || status;
    },
    formatDate: function formatDate(date) {
      return (0, _moment.default)(date).format('DD/MM/YYYY');
    },
    formatDuration: function formatDuration(seconds) {
      if (!seconds || seconds === 0) return '--';
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor(seconds % 3600 / 60);
      return "".concat(hours, "h:").concat(minutes.toString().padStart(2, '0'), "min");
    },
    formatPeriodoAplicacao: function formatPeriodoAplicacao(returnDays) {
      if (returnDays === null || returnDays === undefined) return '--';
      return returnDays > 0 ? 'Recorrente' : 'Único';
    },
    truncateText: function truncateText(text, maxLength) {
      if (!text) return '--';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    openApplicationDetailModal: function openApplicationDetailModal(application) {
      this.selectedApplication = application;
      this.showApplicationModal = true;
    },
    startApplication: function startApplication(application) {
      this.showApplicationModal = false;
      this.updateApplicationStatus(application, 'IN_PROGRESS');
    },
    openStatusUpdateModal: function openStatusUpdateModal(application) {
      this.showApplicationModal = false;
      this.$buefy.modal.open({
        parent: this,
        component: {
          template: "\n            <div class=\"modal-card\">\n              <header class=\"modal-card-head\">\n                <p class=\"modal-card-title\">Atualizar Status</p>\n                <button class=\"delete\" @click=\"$parent.close()\"></button>\n              </header>\n              <section class=\"modal-card-body\">\n                <b-field label=\"Selecione o novo status\">\n                  <b-select v-model=\"selectedStatus\" expanded>\n                    <option value=\"PAUSED\">Pausar aplica\xE7\xE3o</option>\n                    <option value=\"FINISHED\">Finalizar aplica\xE7\xE3o</option>\n                  </b-select>\n                </b-field>\n                \n                <div v-if=\"selectedStatus === 'FINISHED'\">\n                  <b-field label=\"Observa\xE7\xE3o\">\n                    <b-input v-model=\"observation\" type=\"textarea\" placeholder=\"Adicione observa\xE7\xF5es sobre a aplica\xE7\xE3o...\"></b-input>\n                  </b-field>\n                  \n                  <b-field label=\"Dias para retorno\">\n                    <b-input v-model=\"returnDays\" type=\"number\" min=\"0\" placeholder=\"Ex: 30\" :disabled=\"isUnicaAplicacao\"></b-input>\n                  </b-field>\n                  \n                  <b-field>\n                    <b-checkbox v-model=\"isUnicaAplicacao\" @input=\"onUnicaAplicacaoChange\">\n                      \xDAnica aplica\xE7\xE3o\n                    </b-checkbox>\n                  </b-field>\n                </div>\n              </section>\n              <footer class=\"modal-card-foot\">\n                <b-button @click=\"$parent.close()\">Cancelar</b-button>\n                <b-button type=\"is-primary\" @click=\"updateStatus\">Atualizar</b-button>\n              </footer>\n            </div>\n          ",
          data: function data() {
            return {
              selectedStatus: 'PAUSED',
              returnDays: application.returnDays || '',
              isUnicaAplicacao: false,
              observation: '',
              application: application
            };
          },
          methods: {
            onUnicaAplicacaoChange: function onUnicaAplicacaoChange(value) {
              if (value) {
                this.returnDays = '0';
              } else {
                this.returnDays = '';
              }
            },
            updateStatus: function updateStatus() {
              var returnDaysValue = null;
              if (this.selectedStatus === 'FINISHED') {
                returnDaysValue = this.isUnicaAplicacao ? 0 : parseInt(this.returnDays) || null;
              }
              var observationValue = this.selectedStatus === 'FINISHED' ? this.observation : null;
              this.$parent.close();
              this.$parent.$parent.updateApplicationStatus(application, this.selectedStatus, returnDaysValue, observationValue);
            }
          }
        },
        hasModalCard: true
      });
    },
    resumeApplication: function resumeApplication(application) {
      this.showApplicationModal = false;
      this.updateApplicationStatus(application, 'IN_PROGRESS');
    }
  },
  mounted: function mounted() {
    var _this$farm2;
    if ((_this$farm2 = this.farm) !== null && _this$farm2 !== void 0 && _this$farm2.id) {
      this.getApplications();
    }
  }
};